module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "List of Maps"
    }
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Contents#ch1"
    }
  }, [_c('b', [_vm._v("LIST OF MAPS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map1"
    }
  }, [_vm._v("Map 1: Far East Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map2"
    }
  }, [_vm._v("Map 2: Proposed Sites for the Naval Base")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map3"
    }
  }, [_vm._v("Map 3: Malaya")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map4"
    }
  }, [_vm._v("Map 4: Japanese Advance in the Malayan Peninsula")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map5"
    }
  }, [_vm._v("Map 5: Japanese Attack on Northern Malaya, 7/8 December 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map6"
    }
  }, [_vm._v("Map 6: Kota Bahru, 8 December 1941")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map7"
    }
  }, [_vm._v("Map 7: Jitra")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map8"
    }
  }, [_vm._v("Map 8: WESTFORCE Disposition in Johore, 14 January 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map9"
    }
  }, [_vm._v("Map 9: Northern Johore, 15 January 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map10"
    }
  }, [_vm._v("Map 10: Johore Bahru, January 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map11"
    }
  }, [_vm._v("Map 11: Disposition of Troops on Singapore Island, 8 February 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map12"
    }
  }, [_vm._v("Map 12: Japanese Attack, Singapore, February 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "hano",
    attrs: {
      "id": "rmap13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044174_Abbreviations#map13"
    }
  }, [_vm._v("Map 13: The Japanese Assault and Advance and the Final Defense of the Perimeter, Singapore")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea88e88c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253044174_Maps.vue
// module id = 75
// module chunks = 0